import { render, staticRenderFns } from "./AppAlertsCoaAlertsConfigAlgorithm.vue?vue&type=template&id=ed1bafca&scoped=true&"
import script from "./AppAlertsCoaAlertsConfigAlgorithm.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaAlertsConfigAlgorithm.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaAlertsConfigAlgorithm.vue?vue&type=style&index=0&id=ed1bafca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1bafca",
  null
  
)

export default component.exports